"use strict";

/*global  jQuery*/
//$(function () {
jQuery(function ($) {
  //読み込みが完了
  $(window).on('load',function () { 
    console.log('jQuery Page Loaded.');
    if ($(this).scrollTop() > 100) {
      $(".btn-pagetop").addClass('visible');
      $(".site-header").addClass('slim');
    } else {
      $(".btn-pagetop").removeClass('visible');
      $(".site-header").removeClass('slim');
    }
  });
  
  /* iOS動作時の調整処理 */
  $(document).on("touchstart", ".menu-btn", function (event) {
    event.stopPropagation();
  });
  /* ハンバーガーメニューによる開閉処理 */
  $(document).on("click", ".menu-btn.close", function () {
    $(".sp-menu").addClass("open");
    $(".cover").addClass("open");
    $(".cover").removeClass("close");
    $(".sp-menu").removeClass("close");
    $(".menu-btn").addClass("open");
    $(".menu-btn").removeClass("close");
  });
  $(document).on("click", ".menu-btn.open,.cover.open", function () {
    $(".sp-menu").addClass("close");
    $(".sp-menu").removeClass("open");
    $(".cover").removeClass("open");
    $(".cover").addClass("close");
    $(".menu-btn").removeClass("open");
    $(".menu-btn").addClass("close");
  });
  
    //ページトップ戻るボタン 表示ギミック
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".btn-pagetop").addClass('visible');
      $(".site-header").addClass('slim');
    } else {
      $(".btn-pagetop").removeClass('visible');
      $(".site-header").removeClass('slim');
    }
  });
  
  //ページトップ戻るボタン 動作
  $(document).on("click", ".btn-pagetop", function () {
   console.log('DOM Content Loaded.');
    $('body,html').velocity("scroll", 500);
  });
  
  // スムーズスクロール 
  $(document).on('click', 'a[href*=\\#]:not([href=\\#])', function (event) {
    var href = $(this).attr("href"),
    target = $(href === "#" || href === "" ? 'html' : href);
    target.velocity("scroll", 500);
    return false;
  });
  
//  $('.top-slide').slick({
//    dots: true,
//    infinite: true,
//    speed: 300,
//    slidesToShow: 1,
//    centerMode: true,
//    autoplay: true,
//    autoplaySpeed: 3000,
//    variableWidth: true,
//    pauseOnFocus: false,
//    pauseOnHover: false,
//    responsive: [{
//      breakpoint: 800,
//      settings: {
//        centerMode: false,
//        variableWidth: false
//      }
//    }]
//  });
  

  

  
  
});

//touchstartに対応してたらtouchstart、してなければclick
const myTap = window.ontouchstart===null?"touchstart":"click";



// SmoothScroll
//var scroll = new SmoothScroll('a[href*="#"]');
//var scroll = new SmoothScroll('[data-scroll]');

// luminous
//var luminousTrigger = document.querySelectorAll('.luminous');
//new LuminousGallery(luminousTrigger);

// DOM読み込み完了
document.addEventListener('DOMContentLoaded', function(e) {
  console.log('DOM Content Loaded.');
  var menubtn = document.querySelectorAll('.btn-menu')[0];
  var menu = document.querySelectorAll('.site-menu .menu')[0];
  
  var menuParent = document.getElementsByClassName('menu-item-has-children');
  for( var i = 0; i < menuParent.length; i++ ) {
    menuParent[i].insertAdjacentHTML('afterbegin','<div class="toggle-submenu close"></div>');
  }
  
  var toggleMenu = document.getElementsByClassName('toggle-submenu');
  for( var i = 0; i < toggleMenu.length; i++ ) {
    toggleMenu[i].addEventListener(myTap, function(e) {
      var t=e.target;
      this.classList.toggle('close');
      this.classList.toggle('open');
      t.parentNode.querySelector('.sub-menu').classList.toggle('close');
      t.parentNode.querySelector('.sub-menu').classList.toggle('open');
    }, false);
  }
    
  //  スマホ用メニュ開閉処理
  menubtn.addEventListener(myTap, function() {
    menubtn.classList.toggle('close');
    menubtn.classList.toggle('open');
    menu.classList.toggle('close');
    menu.classList.toggle('open');
  }, false);
  
}, false);

// 完全に読み込み完了
window.addEventListener('load', function() {
  console.log('Page Loaded.');
  // Masonry
var elem = document.querySelector('.container-masonry');
  if(elem != null) {
    var msnry = new Masonry( elem, {
    // options
    itemSelector: '.masonry-item',
    percentPosition: true,
    isAnimated:true,
//      fitWidth: true,
    });
  }
});
